import React from 'react';

//Calling React's Context API in order to pass auth state value
//to all of the components inside App component.
const AuthUserContext = React.createContext(null);

export default AuthUserContext;
